export default {
  vendorAccept: {
    method: 'get',
    url: '/client/vendor/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/client/vendor/list'
  },
  'vendor-add': {
    method: 'post',
    url: '/client/vendor'
  },
  'vendor-edit': {
    method: 'put',
    url: '/client/vendor/ID'
  },
  'vendor-delete': {
    method: 'delete',
    url: '/client/vendor'
  },
  find: {
    method: 'get',
    url: '/client/vendor/find?key=KEY'
  },
  checkInvitation: {
    method: 'get',
    url: '/client/vendor/check-invitation',
    headers: {
      tokenInvite: ''
    }
  }
}
